module.exports = __webpack_public_path__ + "img/credit.7232b2bd.svg";